<!-- Body Content-->
<div class="md:pt-3 pt-2 md:px-4 px-3 pb-8 mb-4">
  <div class="flex align-items-center justify-content-between">
    <h1 class="text-base md:text-base md:text-lg text-900 flex align-items-center mb-0 line-height-1">
      {{'CAMPAIGN.LIST' | translate}}
      <!-- <i class="fa fa-circle-question text-xl text-600 cursor-pointer ml-2" pTooltip="This is a sample!" tooltipStyleClass="text-xs"></i> -->
      <a class="inline-flex align-items-center py-1 px-2 border-round text-white text-xs ml-2 bg-purple-600" href="https://guides.unifiedfitnessplatform.ai/showcase/cluikupin0eu04l52bku9g9oq" target="_blank">
        <img width="14" src="/assets/img/interactive-icon.svg" alt="Icon" />
        <span class="ml-2 hidden md:inline-block">Help Guide for {{'CAMPAIGN.LIST' | translate}} </span>
      </a>
    </h1>
    <div class="flex justify-content-end align-items-center">
      <div [routerLink]="['/campaign/create-camapaign']" class="hidden md:inline-block">
        <p-button icon="fa fa-plus" [label]="'CAMPAIGN.NEW_CAMPAIGN' | translate " styleClass="text-sm" />
      </div>
      <div [routerLink]="['/campaign/create-camapaign']" class="md:hidden">
        <p-button icon="fa fa-plus" />
      </div>
      <!-- Three-dot actions menu -->
      <div class="relative ml-2" data-testid="campaign-actions-container">
        <button
          pButton
          pRipple
          type="button"
          icon="fa fa-ellipsis-h"
          class="surface-0 p-button-outlined border-300"
          pStyleClass="@next"
          enterFromClass="hidden"
          enterActiveClass="scalein"
          leaveToClass="hidden"
          leaveActiveClass="fadeout"
          [hideOnOutsideClick]="true"
          aria-label="campaign-actions-menu"
          data-testid="campaign-actions-menu-button">
        </button>
        <ul class="list-none ml-0 px-0 py-2 border-round shadow-2 absolute text-800 hidden origin-top w-15rem right-0 top-0 mt-6 z-2 surface-0 text-left text-sm"
          data-testid="campaign-actions-dropdown">
          <li
            (click)="showBlackoutPeriods()"
            class="px-3 py-2 flex align-items-center hover:surface-100 cursor-pointer"
            aria-label="blackout-periods-menu-item"
            data-testid="blackout-periods-option">
            {{ 'CAMPAIGN.BLACKOUT_PERIODS' | translate }}
          </li>
        </ul>
      </div>
      <!-- /Three-dot actions menu -->
    </div>
  </div>

  <!-- Card -->
  <div class="surface-0 shadow-2 border-round mt-2">
    <div class="py-2 pl-3 pr-0 md:px-3 md:flex align-items-center justify-content-between">
      <div class="flex md:block align-items-center justify-content-between">
        <div>
          <!-- Show skeleton while loading -->
          @if (loading | async) {
            <p-skeleton width="150px" height="20px" />
          } @else {
            <span class="text-900 font-normal text-sm white-space-nowrap mr-2"
              [innerHTML]="'CAMPAIGN.TOTAL_REC' | translate : {count : totalRecordLength.value.totalItems }">
            </span>
          }
        </div>
        <p-button icon="fa fa-search"
          styleClass="md:hidden p-button-text p-0"
          pStyleClass=".filter-search"
          enterFromClass="hidden"
          enterActiveClass="scalein"
          leaveToClass="hidden"
          leaveActiveClass="fadeout"
          [hideOnOutsideClick]="true"
         />
      </div>
      <div class="flex align-items-center">
        <span class="mr-3 white-space-nowrap">{{'AUTOMATION.CREATE.FILTER_BY' | translate}}</span>
        <p-select [options]="filters" [(ngModel)]="selectedFilter" optionLabel="name" styleClass="text-primary font-bold border-0 p-0 shadow-none" filterBy="name"
          (onChange)="selectFilter($event)">
          <ng-template pTemplate="selectedItem">
            @if (selectedFilter) {
              <div class="mt-2">
                <div class="text-sm block text-primary">{{ 'AUTOMATION.CREATE.'+selectedFilter.name | translate}}</div>
              </div>
            }
          </ng-template>
          <ng-template let-filter pTemplate="item">
            <div class="text-sm">{{ 'AUTOMATION.CREATE.'+filter.name | translate }}</div>
          </ng-template>
        </p-select>
      </div>
      <div class="filter-search md:w-20rem mt-2 hidden md:flex pr-3 md:pr-0">
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="fa fa-search" />
          <input type="text" [(ngModel)]="searchText" class="text-sm" pInputText [placeholder]="'CAMPAIGN.SEARCH' | translate" />
        </p-iconfield>
      </div>
    </div>

    <app-data-grid [loading]="loading.value"
      [columnData]="filteredData"
      [columns]="columns"
      [EmptyState]="emptyStateComponent$"
      [selectable]="selectAllData"
      [paginator]="true"
      [totalRecords]="totalRecordLength"
      (loadNextData)="fetchNextSetData($event)"
      (onAction)="onActionEvent($event)"
      [gridName]="'campaign-list'"
     />
  </div>
  <!-- Card -->
</div>
<!-- Body Content-->
